// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_FichaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /rede/ficha/{f|e}/{id} e POST /rede/ficha — a ficha de uma unidade da rede (Full). */
import type { Rede_FichaCampoRow } from './Rede_FichaCampoRow'
import type { Rede_FichaSocioRow } from './Rede_FichaSocioRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Rede_FichaResponseDados {
unidade: string
nome: string
no_sistema: boolean
campos: Rede_FichaCampoRow[]
socios: Rede_FichaSocioRow[]
numero_planilha?: number
vigencia_ate?: string
alerta_contrato?: string
origem?: string
atualizado_por?: string
atualizado_em?: string
}

export type Rede_FichaResponse = ApiResponse<Rede_FichaResponseDados>;

registerResponseContract('Rede_FichaResponse', {
  unidade:         { type: 'string',  required: true },
  nome:            { type: 'string',  required: true },
  no_sistema:      { type: 'boolean', required: true },
  campos: {
    type: 'array',
    required: true,
    items: {
      campo:       { type: 'string',  required: true },
      valor:       { type: 'string',  required: false },
      do_cadastro: { type: 'string',  required: false },
    },
  },
  socios: {
    type: 'array',
    required: true,
    items: {
      id:         { type: 'number',  required: true },
      nome:       { type: 'string',  required: false },
      cpf:        { type: 'string',  required: false },
      nascimento: { type: 'string',  required: false },
      email:      { type: 'string',  required: false },
      tem_login:  { type: 'boolean', required: false },
    },
  },
  numero_planilha: { type: 'number',  required: false },
  vigencia_ate:    { type: 'string',  required: false },
  alerta_contrato: { type: 'string',  required: false },
  origem:          { type: 'string',  required: false },
  atualizado_por:  { type: 'string',  required: false },
  atualizado_em:   { type: 'string',  required: false },
})
